export enum transactionType {
    payment,
    order,
    subscription,
    topUp,
    payOut
}
